import React from 'react';
import { Box, Grid, Typography, IconButton, Container, useTheme } from '@mui/material';
import { Twitter, Facebook, Instagram, Pinterest, Telegram, WhatsApp, Google } from '@mui/icons-material';
import { Link } from 'react-router-dom';

const Footer = () => {
    const theme = useTheme();

    //  const socialIcon = [
    //         {
    //             icon: FacebookOutlinedIcon,
    //             link : "https://www.facebook.com/profile.php?id=100087274201558",
    //         },
    //         {
    //             icon: InstagramIcon,
    //             link : "https://www.instagram.com/invites/contact/?i=ki6sr7vaduel&utm_content=ptc963b",
    //         },
    //         {
    //             icon: WhatsAppIcon,
    //             link : "https://chat.whatsapp.com/EAQsaPpG2uMEj3ifPXL62y",
    //         },
    //         {
    //             icon: TelegramIcon,
    //             link : "https://t.me/jaykhodiyarfashion",
    //         },
    //     ]

    return (
        <Box sx={{
            padding: { xl: '40px', xs: '40px 20px' },
            backgroundImage: 'url(/images/Footer/footer_bg_img.jpg)',
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
        }}>
            <Container maxWidth='xxl'>
                <Box sx={{ pt: 5, pb: 4 }}>
                    <Grid container justifyContent={'center'}>
                        <Grid item xs={12} sm={6} md={4} lg={3.5} xl={4} sx={{ mt: { md: 0, xs: 1 } }}>
                            {/* <Typography variant="h6" gutterBottom>darkfashion</Typography> */}
                            <Box sx={{ width: '180px', height: '80px', mb: 5.4 }}>
                                <img src="/images/header/Light-logo.svg" width="100%" height='100%' />
                            </Box>
                            <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, width: { xl: '64%', xs: '90%' }, fontSize: '16px', lineHeight: '1.8' }}>
                                We sell top quality cloth fabric at the best prices. Variety of colors, textures, and patterns available. Bulk orders and samples welcome!
                            </Typography>
                            <Box sx={{ my: 5 }}>
                                {/* <Link href="" sx={{ textDecoration: 'none' }}> */}
                                    <a href='https://www.facebook.com/share/14E9VpYBi69/'>
                                        <Facebook sx={{ color: '#fff', fontSize: '20px', transition: '0.3s all ease-in-out', mr: 2, '&:hover': { color: theme.palette.primary.gold, backgroundColor: 'transparent' } }} />
                                    </a>
                                {/* </Link> */}
                                {/* <Link href="#" sx={{ textDecoration: 'none' }}> */}
                                    <a href='https://t.me/jaykhodiyarfashion'>
                                        <Telegram sx={{ color: '#fff', fontSize: '20px', transition: '0.3s all ease-in-out', mr: 2, '&:hover': { color: theme.palette.primary.gold, backgroundColor: 'transparent' } }} />
                                    </a>
                                {/* </Link> */}
                                {/* <Link href="#" sx={{ textDecoration: 'none' }}> */}
                                    <a href='https://www.instagram.com/invites/contact/?i=ki6sr7vaduel&utm_content=ptc963b'>
                                        <Instagram sx={{ color: '#fff', fontSize: '20px', transition: '0.3s all ease-in-out', mr: 2, '&:hover': { color: theme.palette.primary.gold, backgroundColor: 'transparent' } }} />
                                    </a>
                                {/* </Link> */}
                                {/* <Link href="#" sx={{ textDecoration: 'none' }}> */}
                                    <a href='https://wa.me/qr/SV3HEFPLHBAYP1'>
                                        <WhatsApp sx={{ color: '#fff', fontSize: '20px', transition: '0.3s all ease-in-out', mr: 2, '&:hover': { color: theme.palette.primary.gold, backgroundColor: 'transparent' } }} />
                                    </a>
                                {/* </Link> */}
                                {/* <Link href="#" sx={{ textDecoration: 'none' }}> */}
                                    <a href='https://g.co/kgs/KcSmyUx'>
                                        <Google sx={{ color: '#fff', fontSize: '20px', transition: '0.3s all ease-in-out', mr: 2, '&:hover': { color: theme.palette.primary.gold, backgroundColor: 'transparent' } }} />
                                    </a>
                                {/* </Link> */}
                            </Box>
                        </Grid>
                        {/* <Grid item xs={12} sm={6} md={4} lg={2.5} xl={2} sx={{ mt: { md: 0, xs: 1 } }}>
                            <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontWeight: 500, fontSize: '16px', letterSpacing: '4px', textTransform: 'uppercase', mb: 2.5 }}>ORDER ASSISTANCE</Typography>
                            <Link style={{textDecoration:'none '}}>
                                <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: '16px', pb: { xl: 2, xs: 1 }, transition: '0.3s all ease-in-out', '&:hover': { color: theme.palette.primary.gold } }}>
                                    Book An Appointment
                                </Typography>
                            </Link>
                            <Link style = {{ textDecoration: 'none' }}>
                                <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: '16px', pb: { xl: 2, xs: 1 }, transition: '0.3s all ease-in-out', '&:hover': { color: theme.palette.primary.gold } }}>
                                    Shipping & Delivery
                                </Typography>
                            </Link>
                            <Link style={{ textDecoration: 'none' }}>
                                <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: '16px', pb: { xl: 2, xs: 1 }, transition: '0.3s all ease-in-out', '&:hover': { color: theme.palette.primary.gold } }}>
                                    Returns & Refunds
                                </Typography>
                            </Link>
                            <Link style={{ textDecoration: 'none' }}>
                                <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: '16px', pb: { xl: 2, xs: 1 }, transition: '0.3s all ease-in-out', '&:hover': { color: theme.palette.primary.gold } }}>
                                    Gift Wrapping
                                </Typography>
                            </Link>
                            <Link style={{ textDecoration: 'none' }}>
                                <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: '16px', pb: { xl: 2, xs: 1 }, transition: '0.3s all ease-in-out', '&:hover': { color: theme.palette.primary.gold } }}>
                                    Follow Your Order
                                </Typography>
                            </Link>
                            <Link style={{ textDecoration: 'none' }}>
                                <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: '16px', pb: { xl: 2, xs: 1 }, transition: '0.3s all ease-in-out', '&:hover': { color: theme.palette.primary.gold } }}>
                                    Stores
                                </Typography>
                            </Link>

                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={2} sx={{ mt: { md: 0, xs: 1 } }}>
                            <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontWeight: 500, fontSize: '16px', letterSpacing: '4px', textTransform: 'uppercase', mb: 2.5 }}>COMPANY</Typography>
                            <Link style={{ textDecoration: 'none' }}>
                                <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: '16px', pb: { xl: 2, xs: 1 }, transition: '0.3s all ease-in-out', '&:hover': { color: theme.palette.primary.gold } }}>
                                    About Us
                                </Typography>
                            </Link>
                            <Link style={{ textDecoration: 'none' }}>
                                <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: '16px', pb: { xl: 2, xs: 1 }, transition: '0.3s all ease-in-out', '&:hover': { color: theme.palette.primary.gold } }}>
                                    Awards
                                </Typography>
                            </Link>
                            <Link style={{ textDecoration: 'none' }}>
                                <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: '16px', pb: { xl: 2, xs: 1 }, transition: '0.3s all ease-in-out', '&:hover': { color: theme.palette.primary.gold } }}>
                                    Our Mission
                                </Typography>
                            </Link>
                            <Link style={{ textDecoration: 'none' }}>
                                <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: '16px', pb: { xl: 2, xs: 1 }, transition: '0.3s all ease-in-out', '&:hover': { color: theme.palette.primary.gold } }}>
                                    Privacy Policy
                                </Typography>
                            </Link>
                            <Link style={{ textDecoration: 'none' }}>
                                <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: '16px', pb: { xl: 2, xs: 1 }, transition: '0.3s all ease-in-out', '&:hover': { color: theme.palette.primary.gold } }}>
                                    Press Release
                                </Typography>
                            </Link>
                            <Link style={{ textDecoration: 'none' }}>
                                <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: '16px', pb: { xl: 2, xs: 1 }, transition: '0.3s all ease-in-out', '&:hover': { color: theme.palette.primary.gold } }}>
                                    Hire Me
                                </Typography>
                            </Link>
                            <Link style={{ textDecoration: 'none' }}>
                                <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: '16px', pb: { xl: 2, xs: 1 }, transition: '0.3s all ease-in-out', '&:hover': { color: theme.palette.primary.gold } }}>
                                    Affiliates And Creators
                                </Typography>
                            </Link>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={2} sx={{ mt: { md: 0, xs: 1 } }}>
                            <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontWeight: 500, fontSize: '16px', letterSpacing: '4px', textTransform: 'uppercase', mb: 2.5 }}>SUPPORT</Typography>
                            <Link style={{ textDecoration: 'none' }}>
                                <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: '16px', pb: { xl: 2, xs: 1 }, transition: '0.3s all ease-in-out', '&:hover': { color: theme.palette.primary.gold } }}>
                                    FAQ
                                </Typography>
                            </Link>
                            <Link style={{ textDecoration: 'none' }}>
                                <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: '16px', pb: { xl: 2, xs: 1 }, transition: '0.3s all ease-in-out', '&:hover': { color: theme.palette.primary.gold } }}>
                                    Shipping And Returns
                                </Typography>
                            </Link>
                            <Link style={{ textDecoration: 'none' }}>
                                <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: '16px', pb: { xl: 2, xs: 1 }, transition: '0.3s all ease-in-out', '&:hover': { color: theme.palette.primary.gold } }}>
                                    Tracking
                                </Typography>
                            </Link>
                            <Link style={{ textDecoration: 'none' }}>
                                <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: '16px', pb: { xl: 2, xs: 1 }, transition: '0.3s all ease-in-out', '&:hover': { color: theme.palette.primary.gold } }}>
                                    Size Charts
                                </Typography>
                            </Link>
                            <Link style={{ textDecoration: 'none' }}>
                                <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: '16px', pb: { xl: 2, xs: 1 }, transition: '0.3s all ease-in-out', '&:hover': { color: theme.palette.primary.gold } }}>
                                    Gift Cards
                                </Typography>
                            </Link>
                        </Grid> */}
                        <Grid item xs={12} sm={6} md={4} lg={2} sx={{ mt: { md: 0, xs: 1 } }}>
                            <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontWeight: 500, fontSize: '16px', letterSpacing: '4px', textTransform: 'uppercase', mb: 2.5 }}>TALK TO US</Typography>
                            <Link style={{ textDecoration: 'none' }}>
                                <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: '16px', pb: { xl: 2, xs: 1 }, transition: '0.3s all ease-in-out', '&:hover': { color: theme.palette.primary.gold } }}>
                                    Got Questions? Call us
                                </Typography>
                            </Link>
                            <Link style={{ textDecoration: 'none' }}>
                                <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: '16px', pb: { xl: 2, xs: 1 }, transition: '0.3s all ease-in-out', '&:hover': { color: theme.palette.primary.gold } }}>
                                    +91 9099126650
                                </Typography>
                            </Link>
                            <Link style={{ textDecoration: 'none' }}>
                                <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: '16px', pb: { xl: 2, xs: 1 }, transition: '0.3s all ease-in-out', '&:hover': { color: theme.palette.primary.gold } }}>
                                    nakranimahesh102@gmail.com
                                </Typography>
                            </Link>
                            <Link style={{ textDecoration: 'none' }}>
                                <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, fontSize: '16px', pb: { xl: 2, xs: 1 }, transition: '0.3s all ease-in-out', '&:hover': { color: theme.palette.primary.gold } }}>
                                    U-72 1st floor raj mahal AC mall near sita Nagar circle puna gam Rod, Gujarat Surat,-395010
                                </Typography>
                            </Link>
                        </Grid>
                    </Grid>
                </Box>
                <Box sx={{ marginTop: '20px', borderTop: '1px solid #444', padding: '20px 0px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Grid container>
                        <Grid xs={12} sm={6} md={4}>
                            <Typography sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, textAlign:{sm:'start',xs:'center'},fontSize: '16px' }}>© 2025 khodiyar fashion, All Rights Reserved</Typography>
                        </Grid>
                        <Grid xs={12} sm={6} md={8} sx={{display:'flex',justifyContent:{sm:'end',xs:'center'},mt:{xs:2,md:0}}}>
                            <Box>
                                <img src="/images/Footer/payment-icon.png" alt="Visa" />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </Box>

    );
};

export default Footer;
